import React, { useState, useEffect } from 'react'
import { useHistory, Redirect, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import useStateRef from 'react-usestateref';
import { useSelector, useDispatch } from 'react-redux';
import "./HeaderCarolina.css"
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import { getShoppingListDetails } from '../../middleware/getShoppingListDetails';
import { updateShoppingListDetailsAction } from '../../middleware/updateShoppingListDetailsAction';
import { Link } from 'react-router-dom';
import CommonTiles from '../CommonTiles';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { getSearchValueAction } from '../../middleware/getSearchValueAction';
import NavMenu from './NavMenu';

const DesktopHeaderNavContainer = ({ searchQuery, miniCartItemsCount, miniCartItems, profile, navMenu, successMsgState, productSearchPageUrl, contentSearchPageUrl, searchPageUrl, targerter, tileMenu, topRibbenMenu, isPunchout, headerLogo, containerAttr }) => {
 
    const [autoSuggestionResult, setAutoSuggestionResult] = useState("")
    const [profileDetail, setProfileDetail, profileDetailRef] = useStateRef('')
    const [shoppingListDetail, setShoppingListDetail, shoppingListDetailRef] = useStateRef('')
    const [searchValue, setSearchValue, searchValueRef] = useStateRef("")
    const [defaultSearchValue, setDefaultSearchValue, defaultSearchValueRef] = useStateRef(searchQuery ? searchQuery : "")
    const [isLoading, setIsLoading] = useState(false);
    const [productSearchPageUrlState, setProductSearchPageUrlState] = useState(productSearchPageUrl ? productSearchPageUrl : "browse/product-search-results");
    const [contentSearchPageUrlState, setContentSearchPageUrlState] = useState(contentSearchPageUrl ? contentSearchPageUrl : "browse/content-search-results");
    const [searchPageUrlState, setSearchPageUrlState] = useState(searchPageUrl ? searchPageUrl : "browse/product-search-results");
    const [search, setSearch, searchRef] = useStateRef("");
    const history = useHistory()
    const [isActive, setIsActive] = useState(false);
    const dispatch = useDispatch();
    const [linkUrl, setLinkUrl] = useState();
    const [isPunchoutInspect, setIsPunchoutInspect, isPunchoutInspectRef] = useStateRef(false);
    const GetCartCount = useSelector(state => state.miniCartItemCountReducer.response.payload)
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const searchValues = useSelector(state => state.getSearchValue.searchValue)

    const mergeCart = useSelector(state => state.mergeCartReducer)
    const commerceItemDetails = useSelector(state => state.commerceItemDetailsReducer.message)
    const registerMessage = useSelector(state => state.registerMsgReducer.message)
    const updateShoppingLists = useSelector(state => state.updateShoppingListDetailsReducer)
    // const [product, setProduct] = useState(menu[0].contents.MenuZone)
    // const [topMenuTile, setTopMenuTile] = useState(menu[1].contents.MenuZone)
    const location = useLocation();
    const fullPath = location.pathname + location.search;
    const childRules = navMenu?.ContentFolderZone?.[0]?.childRules;
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    const [prevUrl, setPrevUrl, prevUrlRef] = useStateRef('')
    useEffect(() => {
        if (updateShoppingLists.status === true) {
            getShoppingList();
        }
    }, [updateShoppingLists.status])

    useEffect(() => {
        //search = window.location.search
        setSearch(window.location.search)
        const url = history.location.pathname
        url && setPrevUrl(url)
        if (url === '/checkout/inspect/cart') {
            setIsPunchoutInspect(true);
        }
    }, [])

    useEffect(() => {
        window.addEventListener('click', function (e) {
            //if (props.containerObject && props.containerObject.attributes.isCheckOutPage != "Y") {
            var taEle = document.getElementById('ta-mobile');
            if (taEle && taEle.contains(e.target)) {
                // Clicked in box
            } else {
                // Clicked outside the box
                setAutoSuggestionResult("")
                //setSearchProductDetails("")
            }
            //}
        });
    }, [])


    const handleMouseEnter = () => {
        setIsActive(true);
    };

    const handleMouseLeave = () => {
        setIsActive(false);
    };

    useEffect(() => {
        if (searchQuery) {
            setDefaultSearchValue(searchQuery)
        }
    }, [searchQuery])

    const getShoppingList = () => {

        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list`, {
            method: 'GET'
        })
            .then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    // setShoppingListDetail((JSON.parse(res.response).response))
                    setShoppingListDetail((JSON.parse(res.response).response))
                    dispatch(getShoppingListDetails(JSON.parse(res.response).response))
                    dispatch(updateShoppingListDetailsAction(false));
                } else {
                    const error = res._ERROR_MESSAGE_;
                }
            })
    }

    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in destopheadernav page loader true");
        } else {
            console.log("log in destopheadernav page loader false");
            if (profileDetails) {
                if (profileDetails.transient) {
                } else {
                    getShoppingList();
                }
            }
        }
    }, [profileDetails])

    const handleSearchAutoSuggestion = (event) => {
        let keyword = event.target.value;
        setSearchValue(encodeURI(keyword))
        setDefaultSearchValue(keyword)
        dispatch(getSearchValueAction(keyword))
    }

    useEffect(() => {
        if (searchValues) {
            setDefaultSearchValue(searchValues)
        }
    }, [searchValues])

    useEffect(() => {
        let params = new URLSearchParams(searchRef.current)
        if (params.get("tab") === null && searchQuery === "" && searchValueRef.current === "") {
            dispatch(getSearchValueAction(""))
            setDefaultSearchValue("")
        } else {
            if (params.get("q")) {
                setDefaultSearchValue(params.get("q"))
            }
        }
    }, [])

    useEffect(() => {
        setAutoSuggestionResult("")
        if (searchValueRef.current && searchValueRef.current.length >= 3) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/static/fetch-suggestions-for-global-search/${searchValueRef.current}`,
                { method: "GET" }
            ).then((res) => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setAutoSuggestionResult(res.response)
                        dataLayerAutocomplete(searchValueRef.current, res.dataLayerResponse)
                    }
                })
        } else {
            setAutoSuggestionResult("")
        }
    }, [searchValueRef.current])

    function dataLayerAutocomplete(searchTerm, sugg) {
        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push({
                "event": "type_ahead",
                "search_term": searchTerm,
                "suggestions": sugg
            });
        }
    }

    const handleAccountLogin = (event) => {
        event.preventDefault()
        dispatch(redirectUrlAction("/account/landing"))
        if (event.ctrlKey || event.metakey) {
            window.open("/account/login", "_blank")
        } else {
            history.push("/account/login")
        }
    }
    const handleListLogin = (event) => {
        event.preventDefault()
        dispatch(redirectUrlAction("/account/list"))
        if (event.ctrlKey || event.metakey) {
            window.open("/account/login?resume=list", "_blank")
        } else {
            history.push("/account/login?resume=list")
        }
    }
    const handleLogOut = (event) => {
        event.preventDefault()
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/logout`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    localStorage.clear();
                    // updating cart count
                    if (!event.ctrlKey) {
                        window.location.href = '/account/login?DPSLogout=true'
                    }
                    // dispatch(updateProfileDetailsAction(true))
                    // var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/mini-cart-count`
                    // dispatch(miniCartItemCountAction(Url))

                } else {
                    // setIsLoading(false)
                    const error = res._ERROR_MESSAGE_;
                    // setErrorMessage(error);
                    //document.getElementById("login-message-error-div").classList.remove("d-none");
                }
            })
    };

    function handleSubmitData(event) {
        event.preventDefault()
        var formData = new FormData(event.target);
        var check = formData.get("q");
        if (check != "" && check.length >= 1) {
            //console.log('encodeURI(check) ---- ', encodeURI(check))
            //console.log('encodeURIComponent(check) ---- ', encodeURIComponent(check))
            var encodeQueryStr = encodeURIComponent(check)
            setDefaultSearchValue(check)
            history.push("/" + productSearchPageUrlState + "?q=" + encodeQueryStr + "&product.type=Product&tab=p")
        }
    }

    return (
        <>

            {/* <div className='d-lg-block d-md-none d-none'> */}

            <div className={`c-top-link ${containerAttr.section1Css ?? ""}`}>
                {profileDetails && profileDetails.userTypeCheck && Object.keys(profileDetails.userTypeCheck).length > 0 &&
                    profileDetails.userTypeCheck.user != "csr" && profileDetails.userTypeCheck.user != "imperson" && (profileDetails.userTypeCheck.showExtrinsics == true || profileDetails.userTypeCheck.showExtrinsics == false) ?
                    <>
                        <div className="row cb-top-link py-1 bg-color">
                            <div className="col-5 my-1 font-login-reg">
                                <p className="m-0">
                                    {profileDetails.userTypeCheck && profileDetails.userTypeCheck.showExtrinsics && profileDetails.userTypeCheck.showExtrinsics == true && <span className="fwb">
                                        {profileDetails.userTypeCheck && profileDetails.userTypeCheck.firstName ? profileDetails.userTypeCheck.firstName + " - " : ""}</span>}
                                    Welcome to the Carolina Punchout Catalog for <span className="fwb">{profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ? profileDetails.userTypeCheck.punchoutClient + '!' : '!'}</span>
                                </p>
                            </div>
                            <div className='col-7 full-width-common-tile'>
                                <ul className='list-sty d-flex justify-content-end '>

                                    <CommonTiles profile={profile}
                                        miniCartItemsCount={miniCartItemsCount}
                                        miniCartItems={miniCartItems}
                                        targerter={targerter}
                                        handleAccountLogin={handleAccountLogin}
                                        handleLogOut={handleLogOut}
                                        handleListLogin={handleListLogin}
                                        shoppingListDetailRef={shoppingListDetailRef.current}
                                        menuTile={topRibbenMenu?.ContentFolderZone?.[0]?.childRules ?? []}
                                    />

                                </ul>
                            </div>
                            {/* <div className="col my-1 text-end fwb link-style-num">
                                Customer Service&nbsp;800.334.5551·
                            </div> */}
                        </div>
                    </> :
                    <div className='d-flex py-1'>

                        {profile && profile.transient && profile.transient == true ?
                            <div className='col-4 my-1 font-login-reg'>
                                <Link className='link-style-login' to={{ pathname: '/account/login?resume=prev', state: { previousUrl: prevUrlRef.current } }} style={{ cursor: 'pointer' }} >Login</Link> or <Link className='link-style-login' to={{ pathname: '/account/login?resume=prev', state: { previousUrl: prevUrlRef.current } }} style={{ cursor: 'pointer' }}  >Register</Link>
                            </div>
                            : profile && profile.userType ? <>
                                <div className='col-4 my-1 font-reg-user font-login-reg'>
                                    Welcome back, <strong>{profile && profile.firstName ? profile.firstName : ""}&nbsp;&nbsp;{profile && profile.lastName ? profile.lastName + " " : ""}</strong> <Link className='link-style-login' style={{ cursor: 'pointer' }} onClick={handleLogOut} > (Not {profile && profile.firstName}?</Link>)
                                </div> </>
                                :
                                <div className='col-4 my-1 font-login-reg'>
                                    <Link className='link-style-login' style={{ cursor: 'pointer' }} >Login</Link> or <Link className='link-style-login' style={{ cursor: 'pointer' }} >Register</Link>
                                </div>
                        }

                        {!isPunchoutInspectRef.current ?
                            <div className='col-8 full-width-common-tile'>
                                <ul className='list-sty d-flex justify-content-end '>

                                    <CommonTiles profile={profile}
                                        miniCartItemsCount={miniCartItemsCount}
                                        miniCartItems={miniCartItems}
                                        targerter={targerter}
                                        handleAccountLogin={handleAccountLogin}
                                        handleLogOut={handleLogOut}
                                        handleListLogin={handleListLogin}
                                        shoppingListDetailRef={shoppingListDetailRef.current}
                                        menuTile={topRibbenMenu?.ContentFolderZone?.[0]?.childRules ?? []}
                                    />

                                </ul>
                            </div>
                            : ''
                        }
                    </div>
                }
            </div>

            {/* </div> */}
            {/* <div className='d-lg-block d-md-none d-none'> */}
            <nav aria-label='desktop-main-navigation'>
            <div className='boxShadow bg-white cbHeader'>
                <div className={`pb-1 d-flex ${containerAttr.section2Css ?? ""}`}>
                    <div className="col-6 logo">
                        {!isPunchoutInspectRef.current ?
                            <Link to="/" title="Carolina Biological Supply logo">
                                <img fetchpriority="high" src={headerLogo ? headerLogo : `/vaststatic/deployed-assets/CbSite/logo.svg`} alt="Carolina Biological Supply" />
                            </Link>
                            :
                            <img fetchpriority="high" src={headerLogo ? headerLogo : `/vaststatic/deployed-assets/CbSite/logo.svg`} alt="Carolina Biological Supply" />
                        }
                    </div>
                    {!isPunchoutInspectRef.current ?
                        <div className='col-6 full-width-common-tile'>
                            <ul className='list-sty d-flex float-end'>

                                <CommonTiles profile={profile}
                                    miniCartItemsCount={miniCartItemsCount}
                                    miniCartItems={miniCartItems}
                                    targerter={targerter}
                                    handleAccountLogin={handleAccountLogin}
                                    handleLogOut={handleLogOut}
                                    handleListLogin={handleListLogin}
                                    shoppingListDetailRef={shoppingListDetailRef.current}
                                    menuTile={tileMenu?.ContentFolderZone?.[0]?.childRules ?? []}
                                />

                            </ul>
                        </div>
                        : ''
                    }


                </div>

                {!isPunchoutInspectRef.current ?
                    <nav className={`navbar navbar-expand-lg header-padding-row nav-common d-md-none d-none d-lg-block ${containerAttr.section3Css ?? ""}`}>
                        <div className="container-fluid px-0 tab-order-style">
                            <div className="collapse navbar-collapse bg-color-green rounded" id="navbarSupportedContent">
                                <ul className="navbar-nav border-ryt-green mb-2 mb-lg-0">
                                    {childRules && childRules.map((rule, index) => (
                                        <NavMenu
                                            key={index}
                                            isActive={isActive}
                                            handleMouseEnter={handleMouseEnter}
                                            handleMouseLeave={handleMouseLeave}
                                            rule={rule}
                                            isPunchout={isPunchout}
                                        />

                                    ))}
                                </ul>
                            </div>

                            <form id="mainSearchForm" method="get" onSubmit={handleSubmitData} className="c-search-form-control d-flex col-lg-7 order-2 order-lg-3 c-search-form">
                                <input type="search" id="q" size="100" name="q" placeholder="Search by Keyword or item #" className="form-control me-lg-2 global-search"
                                    onChange={handleSearchAutoSuggestion} maxlength="100" value={defaultSearchValueRef.current ? defaultSearchValueRef.current : ""} />
                                {/* <button className="btn btn-primary d-none d-lg-block" type="submit" id="search-submit" value="Search"></button> */}
                                {/* <i className="btn btn-primary d-none d-lg-block bi bi-search"></i> */}
                                <button className="d-none d-lg-block" type="submit" id="search-submit" value="Search"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                </svg></button>

                            </form>
                        </div>
                        {successMsgState && fullPath !== '/account/landing?create=true' && fullPath !== '/account/school' && fullPath !== '/checkout/school' ?
                            <div className={`alert mt-3 ${successMsgState && successMsgState.tempB2IMsg ? 'alert-danger d-block' : successMsgState && successMsgState.accountSuccCreateMsg ? 'alert-success d-block' : 'd-none'} `} role="alert">
                                {successMsgState && successMsgState.tempB2IMsg ? successMsgState.tempB2IMsg :
                                    successMsgState && successMsgState.accountSuccCreateMsg ? successMsgState.accountSuccCreateMsg : ''}
                            </div>
                            : ''}

                    </nav>
                    : ''
                }



                <div className={`col-md-12 col-12 ta-results ${autoSuggestionResult && autoSuggestionResult.length > 0 ? "" : "d-none"}`}>
                    <div id="ta-mobile" className={`col-md-5 ms-0 col-9 ${autoSuggestionResult ? "" : "d-none"}`}>
                        <p className='bw'>Products Suggestions: </p>
                        <div className=''>
                            {autoSuggestionResult ? autoSuggestionResult.map((product) => {
                                return (<>
                                    <span id="ta-suggession" className="sugg1">
                                        <ul className="sugg2">
                                            <Link className="search-autocompleted" to={product.productUrl ? product.productUrl : ""} dangerouslySetInnerHTML={{ __html: product.productName ? product.productName : product.productSeoName ? product.productSeoName : "" }}></Link>
                                        </ul>
                                    </span>
                                </>)
                            }) : ""}
                            <div className='col-12 see-all-suggestion'>
                                <Link className="btn-primary" to={`/${productSearchPageUrlState}?q=` + encodeURIComponent(searchValueRef.current) + `&product.type=Product&tab=p`}>See All Results</Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </nav>

            {registerMessage &&
                <div className="pad20b0">
                    <div className="alert alert-success d-block" role="alert">
                        <p></p>
                        {registerMessage}
                    </div>
                </div>
            }

            {/* </div > */}
            {/* Merge Cart Modal */}
            {/* <Modal/> */}
        </>
    )
}

export default DesktopHeaderNavContainer
